import { render, staticRenderFns } from "./QI.vue?vue&type=template&id=424a0f6a&scoped=true&"
import script from "./QI.vue?vue&type=script&lang=js&"
export * from "./QI.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "424a0f6a",
  null
  
)

export default component.exports